import React from "react";
import "./Button.scss";

interface ButtonProps {
  text?: string;
  onClick?: (e: React.FormEvent) => void;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  className?: string;
  style?: React.CSSProperties;
}

const Button: React.FC<ButtonProps> = ({
  text = "SEND",
  onClick,
  disabled = false,
  type = "button",
  className = "",
  style = {},
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`send-button ${className}`}
      style={style}
    >
      {text}
    </button>
  );
};

export default Button;
